import React from 'react'
import { useTable, useGlobalFilter } from 'react-table'
import { Box, CircularProgress } from '@mui/material'
import { t } from 'i18next'
import './DynamicTable.css'

function DynamicTable({ columns, data, loadingData }) {
  const tableInstance = useTable({ columns, data: data ?? [] }, useGlobalFilter)

  const { getTableProps, getTableBodyProps, headerGroups, rows, prepareRow } =
    tableInstance

  return (
    <div
      className="table-container-search-invoice"
      data-testid="container-dynamic-table">
      <div className="table-wrapper-search-invoice">
        <table
          {...getTableProps()}
          className="dynamic-table-no-horizontal-borders"
          data-testid="table-dynamic">
          <thead>
            {headerGroups.map((headerGroup, groupIndex) => {
              return (
                <tr
                  {...headerGroup.getHeaderGroupProps()}
                  key={`header-group-${groupIndex}`}>
                  {headerGroup.headers.map((column, columnIndex) => {
                    return (
                      <th
                        {...column.getHeaderProps()}
                        style={{
                          width: column.width || 'auto',
                        }}
                        key={`header-${groupIndex}-${column.id}-${columnIndex}`}>
                        {column.render('Header')}
                      </th>
                    )
                  })}
                </tr>
              )
            })}
          </thead>
          <tbody {...getTableBodyProps()}>
            {loadingData && (
              <tr key="loading-row">
                <td colSpan={columns.length}>
                  <Box className="loader-search-invoice">
                    <CircularProgress color="primary" size={30} />
                  </Box>
                </td>
              </tr>
            )}
            {!loadingData && data?.length === 0 ? (
              <tr key="no-data-row">
                <td colSpan={columns.length}>
                  <Box className="not-search-invoice-data">
                    {t('GENERIC_MODAL.NO_ITEMS_FOUND')}
                  </Box>
                </td>
              </tr>
            ) : null}
            {rows?.map((row, rowIndex) => {
              prepareRow(row)
              return (
                <tr
                  {...row.getRowProps()}
                  key={`row-${rowIndex}-${row.id || rowIndex}`}>
                  {row.cells.map((cell, cellIndex) => (
                    <td
                      style={{
                        width: cell.column.width || 'auto',
                      }}
                      {...cell.getCellProps()}
                      key={`cell-${rowIndex}-${cellIndex}-${cell.column.id}`}>
                      {cell.render('Cell')}
                    </td>
                  ))}
                </tr>
              )
            })}
          </tbody>
        </table>
      </div>
    </div>
  )
}

export default DynamicTable
